import { useEffect, useState } from "react";

const KEY = "pf_cookie_consent";
const EVT = "pf-consent";
const GA_ID = process.env.REACT_APP_GA_ID;

export const getConsent = () => localStorage.getItem(KEY);

export const setConsent = (value) => {
  if (value) localStorage.setItem(KEY, value);
  else localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVT));
};

export const useConsent = () => {
  const [c, setC] = useState(getConsent());
  useEffect(() => {
    const on = () => setC(getConsent());
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  return c;
};

let loaded = false;
export const loadAnalytics = () => {
  if (!GA_ID || loaded) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
};

export const trackPage = (path, title) => {
  if (loaded && window.gtag) window.gtag("event", "page_view", { page_path: path, page_title: title });
};

export const analyticsConfigured = () => Boolean(GA_ID);
